export enum GradeTypes {
  One = 1,
  Two,
  Three,
  Four,
  Five
}
